import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlobalComponent } from './global/global.component';

const routes: Routes = [
  {
    path: '',
    component: GlobalComponent,
    children: [
      // Home
      { path: '', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule), data: { title: "Homepage" } },
      { path: 'cloud-insights', loadChildren: () => import('./components/pages/cloud-insights/cloud-insights.module').then(m => m.CloudInsightsModule), data: { title: "Cloud Insights" } },
      { path: 'tool', loadChildren: () => import('./components/pages/url/url.module').then(m => m.UrlModule),data: { title: "URL Check" }  },
      { path: 'files', loadChildren: () => import('./components/pages/files/files.module').then(m => m.FilesModule), data: { title: "Files" } },
      { path: 'threat-library', loadChildren: () => import('./components/pages/threats/threats.module').then(m => m.ThreatsModule), data: { title: "Threat Library" } },

      { path: 'security-advisories', loadChildren: () => import('./components/pages/security-advisory/security-advisory.module').then(m => m.SecurityAdvisoryModule), data: { title: "Security Advisories" } },

      // Services
      { path: 'service-details/:id', loadChildren: () => import('./components/pages/service-details/service-details.module').then(m => m.ServiceDetailsModule), data: { title: "Service Details" } },
      // Pricing
      // Pages
      { path: 'error', loadChildren: () => import('./components/pages/error-page/error-page.module').then(m => m.ErrorPageModule), data: { title: 'Error 404' } },
      // Blog
      { path: 'blogs', loadChildren: () => import('./components/pages/blogs/blogs.module').then(m => m.BlogsModule), data: { title: "Blogs" } },

      // Contact
      { path: 'contact', loadChildren: () => import('./components/pages/contact/contact.module').then(m => m.ContactModule), data: { title: "Contact Us" } },
      { path: '**', loadChildren: () => import('./components/pages/error-page/error-page.module').then(m => m.ErrorPageModule), data: { title: 'Error 404' } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'top'})],
  exports: [RouterModule],

})
export class AppRoutingModule { }
